import { render } from "./RegistrationFormSettingsModal.vue?vue&type=template&id=7e1482f4&scoped=true"
import script from "./RegistrationFormSettingsModal.vue?vue&type=script&lang=js"
export * from "./RegistrationFormSettingsModal.vue?vue&type=script&lang=js"

import "./RegistrationFormSettingsModal.vue?vue&type=style&index=0&id=7e1482f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1482f4"]])

export default __exports__